import type { ApplicantDetails } from '@/api/schema';

type DetailField = {
  name: keyof ApplicantDetails;
  label: string;
  maxLength?: number;
  type?: 'number' | 'textarea';
  hint?: string;
};

export const APPLICANT_DETAIL_FIELDS: DetailField[] = [
  { name: 'highest_qualification', label: 'Highest qualification', maxLength: 200 },
  {
    name: 'total_experience_years',
    label: 'Total experience (years)',
    type: 'number',
    hint: 'Enter 0 if you are starting your career.',
  },
  { name: 'current_job_title', label: 'Current or most recent job title', maxLength: 200 },
  { name: 'current_employer', label: 'Current or most recent employer', maxLength: 200 },
  {
    name: 'experience_summary',
    label: 'Work experience',
    maxLength: 2000,
    type: 'textarea',
    hint: 'Include previous roles, responsibilities and relevant internships.',
  },
  { name: 'skills', label: 'Skills and certifications', maxLength: 1000, type: 'textarea' },
  { name: 'languages', label: 'Languages spoken', maxLength: 300 },
  {
    name: 'availability',
    label: 'Availability / notice period',
    maxLength: 200,
    hint: 'For example, immediately or after four weeks.',
  },
];
